/**
 * 描述：租户管理--所有用户
 * 日期：2017-10-09
 * 作者：liu_jinming
 */
"use strict";
angular.module("listOfRngOfficialsModule", [])
    .controller('listOfRngOfficialsCtrl', ['$scope', '$modalInstance', 'item', 'trsHttpService', function($scope, $modalInstance, item, trsHttpService) {
        initStatus();
        initData();
        /** [initStatus description： 初始化状态] */
        function initStatus() {
            $scope.page = {
                ITEMCOUNT: 0,
                PAGESIZE: 10,
                CURRPAGE: 1,
                PAGECOUNT: 0
            };
            $scope.data = {
                copyCurrPage: 1
            };
            $scope.status = {
                TENANTID: item,
                leaderList: [],
                searchWord: ""
            };
        }
        /** [initData description: 初始化数据] */
        function initData() {
            requestData();
        }
        /** [requestData description: 获取初始数据列表] */
        function requestData() {
            var params = {
                "serviceid": "mlf_tenant",
                "methodName": "queryTenantRelevantInfos",
                "TENANTID": $scope.status.TENANTID,
                "Page_Size": $scope.page.PAGESIZE,
                "Page_NO": $scope.page.CURRPAGE 
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                console.log(data);
                 $scope.status.leaderList = [];
                for(var i = 0; i<data.length-1; i++){
                    $scope.status.leaderList.push(data[i]);
                }
                $scope.page.ITEMCOUNT = data[data.length-1].TOTALNUMBERS;
                $scope.page.PAGECOUNT = data[data.length-1].PAGECOUNT;
            });
        }
        /** [search descriptionss: 搜索地域官员信息] */
        $scope.search = function(){          
            var params = {
                "serviceid": "mlf_tenant",
                "methodName": "queryTenantRelevantInfos",
                "TENANTID": $scope.status.TENANTID,
                "Page_Size": $scope.page.PAGESIZE,
                "Page_NO": $scope.page.CURRPAGE,
                "SearchField": $scope.status.searchWord
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.status.leaderList = [];
                for(var i = 0; i<data.length-1; i++){
                    $scope.status.leaderList.push(data[i]);
                }
                $scope.page.ITEMCOUNT = data[data.length-1].TOTALNUMBERS;
                $scope.page.PAGECOUNT = data[data.length-1].PAGECOUNT;
            });
        };
        /** [jumpToPage description: 跳转到第几页] */
        $scope.jumpToPage = function(){
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };
        /** [requestData description: 前后翻页时的发生数据请求的函数] */
        $scope.requestData = function(){
            requestData();
        };
        /** [cancel description: 取消] */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);